import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Skeleton from '@material-ui/lab/Skeleton';

const SKELETON_ROW_KEYS = [
  'skeleton-row-1',
  'skeleton-row-2',
  'skeleton-row-3'
];

const DrilldownTableSkeletonRows = ({ columns }) => (
  <>
    {SKELETON_ROW_KEYS.map(rowKey => (
      <TableRow key={rowKey}>
        {columns.map(column => (
          <TableCell key={column.key} align={column.align}>
            <Skeleton width="100%" height={20} />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

DrilldownTableSkeletonRows.propTypes = {
  columns: PropTypes.array.isRequired
};

export default DrilldownTableSkeletonRows;
